import Vue from 'vue'
import Router from 'vue-router'

const layout = () => import(`@/components/layout.vue`)
const home = () => import(`@/components/home.vue`)
const reports = () => import(`@/components/reports.vue`)
const internVoice = () => import(`@/components/internVoice.vue`)
const reportExport = () => import(`@/components/export.vue`)
const reportImport = () => import(`@/components/import.vue`)
const reportImport2 = () => import(`@/components/import2.vue`)
const reportImport3 = () => import(`@/components/import3.vue`)
const reportImport4 = () => import(`@/components/import4.vue`)
const reportImport5 = () => import(`@/components/import5.vue`)
const perimeter = () => import(`@/components/perimeter.vue`)
const questionnaire = () => import(`@/components/questionnaire.vue`)
const storeAddress = () => import(`@/components/storeAddress.vue`)
const permission = () => import(`@/components/permissionManagement.vue`)
const vendorInfo = () => import(`@/components/vendorInfo.vue`)

const feedback = () => import(`@/components/feedback/index.vue`)
const feedbackProduct = () => import(`@/components/feedback/product.vue`)
const feedbackReport = () => import(`@/components/feedback/report.vue`)
const feedbackReportCN = () => import(`@/components/feedback/report_zh_cn.vue`)
const feedbackMy = () => import(`@/components/feedback/my.vue`)
const feedbackDeal = () => import(`@/components/feedback/deal.vue`)

const authLayout = () => import(`@/components/auth/index.vue`)
const login = () => import(`@/components/auth/login.vue`)
const registry = () => import(`@/components/auth/registry.vue`)
const callback = () => import(`@/components/auth/callback.vue`)
const vendorLogin = () => import(`@/components/auth/vendorLogin.vue`)

const page404 = () => import(`@/components/page404.vue`)

const routes = [
  { name: 'layout',
    path: '/',
    component: layout,
    redirect: '/reports',
    children: [
      { name: 'home', path: 'home', component: home },
      { name: 'reports', path: 'reports', component: reports, meta: { keepAlive: true } },
      // { name: 'reports', path: 'reports', component: reports},
      { name: 'export', path: 'export', component: reportExport },
      { name: 'import', path: 'import', component: reportImport },
      { name: 'intern_voice', path: 'internVoice', component: internVoice },

      { name: 'import2', path: 'import2', component: reportImport2 },
      { name: 'import3', path: 'import3', component: reportImport3 },
      { name: 'import4', path: 'import4', component: reportImport4 },
      { name: 'import5', path: 'import5', component: reportImport5 },
      { name: 'perimeter', path: 'perimeter', component: perimeter },
      { name: 'questionnaire', path: 'questionnaire', component: questionnaire, meta: { keepAlive: true } },
      { name: 'storeAddress', path: 'storeAddress', component: storeAddress },
      { name: 'permission', path: 'permission', component: permission },
      { name: 'report_deal', path: 'deal', component: feedbackDeal },
      { name: 'quest_report', path: 'report', component: feedbackReportCN },
      { name: 'vendor_info', path: 'vendor_info', component: vendorInfo }
    ]
  },
  { name: 'feedback',
    path: '/feedback',
    component: feedback,
    redirect: '/feedback/product',
    children: [
      // { name: 'product', path: 'product', component: feedbackProduct, meta: { keepAlive: true } },
      { name: 'product', path: 'product', component: feedbackProduct },
      { name: 'report', path: 'report', component: feedbackReport },
      //  { name: 'my', path: 'my', component: feedbackMy, meta: { keepAlive: true } },
      { name: 'my', path: 'my', component: feedbackMy },
      { name: 'deal', path: 'deal', component: feedbackDeal },
      { name: 'report_zh_cn', path: 'report_zh_cn', component: feedbackReportCN }
    ]
  },
  { name: 'auth',
    path: '/auth',
    component: authLayout,
    redirect: '/auth/login',
    children: [
      { name: 'login', path: 'login', component: login },
      { name: 'registry', path: 'registry', component: registry },
      { name: 'callback', path: 'callback', component: callback },
      { name: 'vendor_login', path: 'vendor_login', component: vendorLogin }
    ]
  },
  { path: '*', component: page404 }
]

Vue.use(Router)
export default new Router({
  routes,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js